const Flex = props => {
    const { children, className, vertical, wrap, noWrap, justify, align, style = {}, gap } = props;

    const flexClasses = [
        'kt-flex',
        vertical ? 'kt-flex-column' : 'kt-flex-row',
        justify ? `kt-flex-${justify}` : '',
        align ? `kt-flex-align-${align}` : '',
        wrap ? 'kt-flex-wrap' : '',
        noWrap ? 'kt-flex-no-wrap' : '',
        className || ''
    ].join(' ');

    style.gap = gap || style.gap;

    return (<div 
        {...Object.keys(props).reduce((acc, key) => {
            if(!['children', 'className', 'vertical', 'wrap', 'noWrap', 'justify', 'align', 'style', 'gap'].includes(key)) {
                acc[key] = props[key]
            }
            return acc;
        }, {})} 
        className={flexClasses} 
        style={style}
    >
        {children}
    </div>)
}

Flex.Spacer = () => {
    return (<div className="kt-flex-spacer"></div>)
}

export default Flex;